import {
  prepareProgramAndDependentData,
  removeOrderNameForCloneProgramFlow,
} from './pre-transformers';
import {
  ProgramTransformer,
  ProgramWizardConfig,
  ProgramWizardStepInfo,
} from '@/app/core/components/program-wizard';
import {
  amendSubscriberCode,
  ensureValidCloneFromProgramExists,
} from '@/app/features/products/common';
import { FrontEndProcessingContainer } from '@/app/features/products/common/components/frontend-processing/FrontEndProcessingContainer';
import { ProductDetailsContainer } from '@/app/features/products/common/components/product-details/ProductDetailsContainer';
import { PinningConfigurationContainer } from '@/app/features/products/common/components/pinning-configuration/PinningConfigurationContainer';
import {
  AscendArchivesProgram,
  sequencePromiseFunctions,
} from '@ssar-app/domain';
import { Text } from '@chakra-ui/react';

export const getAscendArchivestSelfServeArchivesProgramWizardConfig =
  async (): Promise<ProgramWizardConfig> => {
    const preTransformer: ProgramTransformer = sequencePromiseFunctions(
      ensureValidCloneFromProgramExists,
      amendSubscriberCode,
      removeOrderNameForCloneProgramFlow,
      prepareProgramAndDependentData,
    );

    const programKeys = {
      'Program Details': ['productInput', 'productDetails'],
      'Input File Selection': ['packagesInput', 'frontEndProcessing'],
      'Pinning Configuration': [
        'packagesInput',
        'frontEndProcessing',
        'thresholds',
      ],
    };

    const steps: ProgramWizardStepInfo[] = [
      {
        key: programKeys['Program Details'],
        title: 'Program Details',
        description: 'Enter program details',
        element: (
          <ProductDetailsContainer keys={programKeys['Program Details']} />
        ),
      },
      {
        key: programKeys['Input File Selection'],
        title: 'Input File Selection',
        description: 'Select Input File',
        element: (
          <FrontEndProcessingContainer
            keys={programKeys['Input File Selection']}
          />
        ),
      },
      {
        key: programKeys['Pinning Configuration'],
        title: 'Pinning Configuration',
        description: <Text whiteSpace={'pre'}>Enter Threshold Values</Text>,
        element: (
          <PinningConfigurationContainer
            keys={programKeys['Pinning Configuration']}
          />
        ),
      },
    ];
    const toReturn: ProgramWizardConfig = {
      steps,
      preTransformer,
      isSaveDraftsAllowed: true,
      isAutoSaveAllowed: true,
      autoSaveTimer: 30 * 1000,
    };
    return Promise.resolve(toReturn);
  };

export const getProgramName = (model: AscendArchivesProgram) => {
  return model?.productInput?.productDetails?.programName || '';
};
